<template>
  <div class="service-end">
    <h3>서비스가 종료되었습니다.</h3>
  </div>
</template>
<style scoped>
.service-end {
  display: flex;
  height: 100vh;
  height: 100dvh;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  background: white;
}
.service-end h3 {
  margin: auto;
  font-family: 'GmarketSans';
}
</style>
